import Vue from 'vue';

import { createHobbitApp } from 'hobbit-base';
import { loadJS } from 'hobbit-base/modules/utils';
import mainHelper from 'hobbit-base/components/bizs/main/main-helper';

// eslint-disable-next-line import/no-extraneous-dependencies
import 'animate.css';

// 常用全局通用组件
import AlloyFinger from 'alloyfinger';
import AlloyFingerPlugin from 'alloyfinger/vue/alloy_finger_vue';
import appView from './app/app.vue'; // App.vue 页面母版
import User from './modules/user'; // 鉴权和用户基本属性相关模块
// 自定义指令
import directives from './directives/index';

Vue.use(directives);

// eslint-disable-next-line import/no-extraneous-dependencies
// const BrowserLogger = require('alife-logger');

// eslint-disable-next-line import/no-dynamic-require
const config = require(`../config/${process.env.VUE_APP_RUNTIME}`);

// const bl = BrowserLogger.singleton({
//   pid: 'epn9tbrnui@2c1a38f63ed8002',
//   appType: 'web',
//   imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
//   sendResource: true,
//   enableLinkTrace: true,
//   behavior: true,
//   enableConsole: true,
//   useFmp: true,
// });

createHobbitApp(appView, config, ({ $hobbit, router }) => {
  const $config = $hobbit.$config;
  const $ctx = $hobbit.$ctx;
  const $fetch = $hobbit.$fetch;
  const $theme = $hobbit.$theme;
  // #region =#=#=#=#=#=#=#=#=#= 扩展项目级别基础模块 =#=#=#=#=#=#=#=#=#=
  const $user = new User($config, $fetch, $ctx);
  Vue.prototype.$user = $user;

  Vue.prototype.$log = () => {};
  Vue.prototype.$ems = () => {};
  // Vue.prototype.$bl = bl;

  if (window.bridge) {
    Vue.prototype.$dsBridge = window.bridge;
  }
  Vue.use(AlloyFingerPlugin, { AlloyFinger });
  // #endregion

  // #region =#=#=#=#=#=#=#=#=#= 初始化业务和语言、时区、主题 =#=#=#=#=#=#=#=#=#=
  // 计算实时时差
  $ctx.vkTimezone = mainHelper.getVKTimezone();

  // 初始化业务码
  mainHelper.bizInit($hobbit);

  // 主题初始化
  $theme.$installer.load = (biz) => import(/* webpackChunkName: "[request]" */ '@/theme/hk.js').then((theme) => theme.default);

  const waitList = [];

  // MOCK配置
  if ($config.fetch.mock) {
    waitList.push(
      import(/* webpackChunkName: "mocks" */ '@/mocks').then((mocks) => {
        $fetch.mockConfig = mocks.default;
      }),
    );
  }

  // 加载调试控制台
  if ($config.site.vconsole && window.top === window && !$ctx.isPC()) {
    waitList.push(loadJS('//s.vipkidstatic.com/fe-static/hobbit/asset/lib/eruda.min.js?v2').then(() => window.eruda.init()));
  }
  // #endregion
  return Promise.all(waitList).catch(() => null);
});
